import asyncRetry from 'async/retry';
import _each from 'lodash/each';
import _map from 'lodash/map';

export default {
  isReady,
  setCustomBaseUrl,
  getCustomBaseUrl,
  getBaseUrl,
  makeUrl,
  request,
  get,
  post,
  del,
};

const BASE_URL = 'https://avid-fs-server-prod.monp-dev.com';
const BASE_URL_DEV = 'https://avid-fs-server-prod.monp-dev.com';
const FORCE_DEV = false;
const MAX_RETRY_MS = 20 * 1000;
const RETRY_TIMES = 20;

let g_custom_base_url = window.localStorage['custom_base_url'] || '';

function isReady() {
  return true;
}

function setCustomBaseUrl(url: string) {
  if (!url) {
    g_custom_base_url = false;
  } else {
    url = url.replace(/\/*$/, '');
    g_custom_base_url = url;
  }
  window.localStorage['custom_base_url'] = g_custom_base_url;
}
window.setCustomBaseUrl = setCustomBaseUrl;

function getCustomBaseUrl(): string {
  return g_custom_base_url;
}

function makeUrl(url: string): string {
  return getBaseUrl() + url;
}

function getBaseUrl(): string {
  let base_url = false;
  if (g_custom_base_url) {
    base_url = g_custom_base_url;
  } else if (FORCE_DEV) {
    base_url = BASE_URL_DEV;
  } else {
    base_url = BASE_URL;
  }
  return base_url;
}

function get(opts, done) {
  opts.method = 'GET';
  request(opts, done);
}
function post(opts, done) {
  opts.method = 'POST';
  request(opts, done);
}
function del(opts, done) {
  opts.method = 'DELETE';
  request(opts, done);
}
function request(opts, done) {
  opts.url = makeUrl(opts.url);
  if (opts.retry) {
    const retry_opts = {
      times: RETRY_TIMES,
      interval: (count) => {
        return Math.min(50 * Math.pow(3, count), MAX_RETRY_MS);
      },
      errorFilter: (err) => {
        let ret = true;
        if (typeof err === 'number' && err > 0 && err < 500) {
          ret = false;
        }
        return ret;
      },
    };
    asyncRetry(retry_opts, (done) => _rawRequest(opts, done), done);
  } else {
    _rawRequest(opts, done);
  }
}

function _rawRequest(
  args,
  done: (err: any, json: any, json2: any, body: string) => void
) {
  function request_done(...args) {
    done(...args);
    done = () => {};
  }

  const { method, track_progress } = args;

  let default_headers: any = {
    Accept: 'application/json',
  };
  let body = null;
  if (args.body instanceof FormData) {
    body = args.body;
  } else if (args.body) {
    body = JSON.stringify(args.body);
    if (args.force_text) {
      default_headers['Content-Type'] = 'text/plain';
    } else {
      default_headers['Content-Type'] = 'application/json';
    }
  }

  let url = args.url;
  if (args.query) {
    const query_s = _map(args.query, (v, k) => {
      return encodeURIComponent(k) + '=' + encodeURIComponent(v);
    }).join('&');
    if (query_s.length > 0) {
      if (url.indexOf('?') > 0) {
        url += '&' + query_s;
      } else {
        url += '?' + query_s;
      }
    }
  }

  const headers = Object.assign({}, default_headers, args.headers);

  const xhr = new XMLHttpRequest();
  if (args.timeout) {
    xhr.timeout = args.timeout;
  }

  xhr.onload = () => {
    let status = xhr.status === 1223 ? 204 : xhr.status;
    let body = false;
    let json = false;
    let err = null;

    body = xhr.response || xhr.responseText;
    const content_type = xhr.getResponseHeader('Content-Type');
    const is_json = content_type && content_type.indexOf('json') !== -1;

    if (body && body.length && is_json) {
      try {
        json = JSON.parse(body);
      } catch (e) {
        err = e;
      }
    }

    if (status < 100 || status > 599) {
      err = 'bad_status';
    } else if (status > 399) {
      err = status;
    }
    request_done(err, json || body, json, body);
  };

  xhr.onerror = () => {
    request_done('xhr_error');
  };
  xhr.ontimeout = () => {
    request_done('timeout');
  };

  xhr.open(method || 'GET', url, true);

  _each(headers, (values, name) => {
    if (!Array.isArray(values)) {
      values = [values];
    }
    values.forEach((value: string) => {
      xhr.setRequestHeader(name, value);
    });
  });

  if (track_progress) {
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        track_progress((e.loaded / e.total) * 100);
      }
    };
  }

  xhr.send(body);
}
